<div
  class="modal fade"
  id="userInfoModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">
          {{ user?.firstName }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body" *ngIf="user">
        <ul class="list-group">
          <li class="list-group-item">
            <strong>Email:</strong> {{ user.email }}
          </li>
          <li class="list-group-item"><strong>Dni:</strong> {{ user.dni }}</li>
          <li class="list-group-item">
            <strong>Telefono:</strong> {{ user.phoneNumber }}
          </li>
          <li class="list-group-item">
            <strong>Fecha creación:</strong> {{ user.createdAt }}
          </li>
          <li class="list-group-item">
            <div class="d-flex justify-content-arround">
              <button
                class="btn-custom me-2"
                [routerLink]="['/routines/', user.id]"
                data-bs-dismiss="modal"
              >
                Rutinas
              </button>
              <button
                class="btn-custom"
                [routerLink]="['/diet-history/', user.id]"
                data-bs-dismiss="modal"
              >
                Alimentación
              </button>
            </div>
          </li>
        </ul>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Cerrar
        </button>

        <button
          type="button"
          class="btn-custom"
          data-bs-toggle="modal"
          data-bs-target="#userConfigModal"
        >
          Configuración
        </button>
      </div>
    </div>
  </div>
</div>
